var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('HeaderNavbar',{attrs:{"activeIndex":'1'}})],1),_c('el-row',[_c('Platform')],1),_c('el-row',[_c('HFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }